import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAuditLogsAsync: build.query<
      GetAuditLogsAsyncApiResponse,
      GetAuditLogsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/AuditLogs/audit-logs`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          action: queryArg.action,
          performedBy: queryArg.performedBy,
        },
      }),
    }),
    refreshAsync: build.mutation<RefreshAsyncApiResponse, RefreshAsyncApiArg>({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Authentication/auth/refresh-token`,
        method: 'POST',
        body: queryArg.refreshTokenRequest,
      }),
    }),
    getCurrentUserAsync: build.query<
      GetCurrentUserAsyncApiResponse,
      GetCurrentUserAsyncApiArg
    >({
      query: () => ({ url: `/backofficeservice/v1/Authentication/auth/me` }),
    }),
    loginAsync: build.mutation<LoginAsyncApiResponse, LoginAsyncApiArg>({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Authentication/auth/login`,
        method: 'POST',
        body: queryArg.loginRequest,
      }),
    }),
    changePasswordAsync: build.mutation<
      ChangePasswordAsyncApiResponse,
      ChangePasswordAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Authentication/auth/change-password`,
        method: 'POST',
        body: queryArg.changePasswordRequest,
      }),
    }),
    getRuntimeRolePermissionsAsync: build.query<
      GetRuntimeRolePermissionsAsyncApiResponse,
      GetRuntimeRolePermissionsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/internal/authorization/roles/${queryArg.roleName}/permissions`,
      }),
    }),
    seedModulesAsync: build.mutation<
      SeedModulesAsyncApiResponse,
      SeedModulesAsyncApiArg
    >({
      query: () => ({
        url: `/backofficeservice/v1/Modules/modules/seed`,
        method: 'POST',
      }),
    }),
    getModulesWithSubModulesAsync: build.query<
      GetModulesWithSubModulesAsyncApiResponse,
      GetModulesWithSubModulesAsyncApiArg
    >({
      query: () => ({
        url: `/backofficeservice/v1/Modules/modules/with-submodules`,
      }),
    }),
    createSubModuleAsync: build.mutation<
      CreateSubModuleAsyncApiResponse,
      CreateSubModuleAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/modules/${queryArg.moduleId}/submodules`,
        method: 'POST',
        body: queryArg.createSubModuleRequest,
      }),
    }),
    getSubModulesAsync: build.query<
      GetSubModulesAsyncApiResponse,
      GetSubModulesAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/modules/${queryArg.moduleId}/submodules`,
      }),
    }),
    deleteSubModuleAsync: build.mutation<
      DeleteSubModuleAsyncApiResponse,
      DeleteSubModuleAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/submodules/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    createScopeAsync: build.mutation<
      CreateScopeAsyncApiResponse,
      CreateScopeAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/scopes`,
        method: 'POST',
        body: queryArg.createScopeRequest,
      }),
    }),
    getAllScopesAsync: build.query<
      GetAllScopesAsyncApiResponse,
      GetAllScopesAsyncApiArg
    >({
      query: () => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/scopes`,
      }),
    }),
    assignRolePermissionAsync: build.mutation<
      AssignRolePermissionAsyncApiResponse,
      AssignRolePermissionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/roles/${queryArg.roleName}/permissions`,
        method: 'POST',
        body: queryArg.assignRolePermissionRequest,
      }),
    }),
    getRolePermissionsAsync: build.query<
      GetRolePermissionsAsyncApiResponse,
      GetRolePermissionsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/roles/${queryArg.roleName}/permissions`,
      }),
    }),
    removeRolePermissionAsync: build.mutation<
      RemoveRolePermissionAsyncApiResponse,
      RemoveRolePermissionAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/roles/${queryArg.roleName}/permissions/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    createModuleAsync: build.mutation<
      CreateModuleAsyncApiResponse,
      CreateModuleAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/modules`,
        method: 'POST',
        body: queryArg.createModuleRequest,
      }),
    }),
    getAllModulesAsync: build.query<
      GetAllModulesAsyncApiResponse,
      GetAllModulesAsyncApiArg
    >({
      query: () => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/modules`,
      }),
    }),
    deleteModuleAsync: build.mutation<
      DeleteModuleAsyncApiResponse,
      DeleteModuleAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/PermissionMatrix/permission-matrix/modules/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getRolePermissionsByRoleNameAsync: build.query<
      GetRolePermissionsByRoleNameAsyncApiResponse,
      GetRolePermissionsByRoleNameAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Permissions/role-permissions/${queryArg.roleName}`,
      }),
    }),
    bulkUpdateRolePermissionsAsync: build.mutation<
      BulkUpdateRolePermissionsAsyncApiResponse,
      BulkUpdateRolePermissionsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Permissions/role-permissions/${queryArg.roleName}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    removeRoleFromUserAsync: build.mutation<
      RemoveRoleFromUserAsyncApiResponse,
      RemoveRoleFromUserAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Roles/users/${queryArg.userId}/roles/${queryArg.roleName}`,
        method: 'DELETE',
      }),
    }),
    assignRoleToUserAsync: build.mutation<
      AssignRoleToUserAsyncApiResponse,
      AssignRoleToUserAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Roles/users/${queryArg.userId}/roles/${queryArg.roleName}`,
        method: 'POST',
      }),
    }),
    getRoleUsersAsync: build.query<
      GetRoleUsersAsyncApiResponse,
      GetRoleUsersAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Roles/roles/${queryArg.roleName}/users`,
      }),
    }),
    deleteRoleAsync: build.mutation<
      DeleteRoleAsyncApiResponse,
      DeleteRoleAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Roles/roles/${queryArg.roleId}`,
        method: 'DELETE',
      }),
    }),
    createRoleAsync: build.mutation<
      CreateRoleAsyncApiResponse,
      CreateRoleAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Roles/roles`,
        method: 'POST',
        body: queryArg.createRoleRequest,
      }),
    }),
    getAllPermissionRolesAsync: build.query<
      GetAllPermissionRolesAsyncApiResponse,
      GetAllPermissionRolesAsyncApiArg
    >({
      query: () => ({ url: `/backofficeservice/v1/Roles/roles` }),
    }),
    getUserContractsByTypeAsync: build.query<
      GetUserContractsByTypeAsyncApiResponse,
      GetUserContractsByTypeAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/UserContracts/user-contracts`,
        params: {
          Type: queryArg['type'],
          OnlyActive: queryArg.onlyActive,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    createUserContractAsync: build.mutation<
      CreateUserContractAsyncApiResponse,
      CreateUserContractAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/UserContracts/user-contracts`,
        method: 'POST',
        body: queryArg.createUserContractRequest,
      }),
    }),
    getUserContractApprovalStatusAsync: build.query<
      GetUserContractApprovalStatusAsyncApiResponse,
      GetUserContractApprovalStatusAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/UserContracts/user-contracts/by-type/${queryArg['type']}/approval-status`,
      }),
    }),
    approveUserContractAsync: build.mutation<
      ApproveUserContractAsyncApiResponse,
      ApproveUserContractAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/UserContracts/user-contracts/${queryArg.contractId}/approve`,
        method: 'POST',
      }),
    }),
    updateUserStatusAsync: build.mutation<
      UpdateUserStatusAsyncApiResponse,
      UpdateUserStatusAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Users/users/${queryArg.userId}/status`,
        method: 'PATCH',
        body: queryArg.updateUserStatusRequest,
      }),
    }),
    updateUserAsync: build.mutation<
      UpdateUserAsyncApiResponse,
      UpdateUserAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Users/users/${queryArg.userId}`,
        method: 'PUT',
        body: queryArg.updateUserRequest,
      }),
    }),
    deleteUserAsync: build.mutation<
      DeleteUserAsyncApiResponse,
      DeleteUserAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Users/users/${queryArg.userId}`,
        method: 'DELETE',
      }),
    }),
    setUserPasswordAsync: build.mutation<
      SetUserPasswordAsyncApiResponse,
      SetUserPasswordAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Users/users/${queryArg.userId}/password`,
        method: 'PUT',
        body: queryArg.setUserPasswordRequest,
      }),
    }),
    getAllUsersAsync: build.query<
      GetAllUsersAsyncApiResponse,
      GetAllUsersAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Users/users`,
        params: {
          RoleName: queryArg.roleName,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    createSystemUserAsync: build.mutation<
      CreateSystemUserAsyncApiResponse,
      CreateSystemUserAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/backofficeservice/v1/Users/users/system`,
        method: 'POST',
        body: queryArg.createSystemUserRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as backofficeApi };
export type GetAuditLogsAsyncApiResponse =
  /** status 200 OK */ AuditLogPagedResult;
export type GetAuditLogsAsyncApiArg = {
  page?: number;
  pageSize?: number;
  action?: string;
  performedBy?: string;
};
export type RefreshAsyncApiResponse =
  /** status 200 OK */ RefreshTokenCommandResponse;
export type RefreshAsyncApiArg = {
  refreshTokenRequest: RefreshTokenRequest;
};
export type GetCurrentUserAsyncApiResponse =
  /** status 200 OK */ CurrentUserDto;
export type GetCurrentUserAsyncApiArg = void;
export type LoginAsyncApiResponse = /** status 200 OK */ LoginResponse;
export type LoginAsyncApiArg = {
  loginRequest: LoginRequest;
};
export type ChangePasswordAsyncApiResponse = unknown;
export type ChangePasswordAsyncApiArg = {
  changePasswordRequest: ChangePasswordRequest;
};
export type GetRuntimeRolePermissionsAsyncApiResponse =
  /** status 200 OK */ RuntimeRolePermissionsDto;
export type GetRuntimeRolePermissionsAsyncApiArg = {
  roleName: string;
};
export type SeedModulesAsyncApiResponse = unknown;
export type SeedModulesAsyncApiArg = void;
export type GetModulesWithSubModulesAsyncApiResponse =
  /** status 200 OK */ ModuleViewModel[];
export type GetModulesWithSubModulesAsyncApiArg = void;
export type CreateSubModuleAsyncApiResponse = /** status 201 Created */ string;
export type CreateSubModuleAsyncApiArg = {
  moduleId: string;
  createSubModuleRequest: CreateSubModuleRequest;
};
export type GetSubModulesAsyncApiResponse =
  /** status 200 OK */ SubModuleViewModel1[];
export type GetSubModulesAsyncApiArg = {
  moduleId: string;
};
export type DeleteSubModuleAsyncApiResponse = unknown;
export type DeleteSubModuleAsyncApiArg = {
  id: string;
};
export type CreateScopeAsyncApiResponse = /** status 201 Created */ string;
export type CreateScopeAsyncApiArg = {
  createScopeRequest: CreateScopeRequest;
};
export type GetAllScopesAsyncApiResponse =
  /** status 200 OK */ ScopeViewModel1[];
export type GetAllScopesAsyncApiArg = void;
export type AssignRolePermissionAsyncApiResponse =
  /** status 201 Created */ string;
export type AssignRolePermissionAsyncApiArg = {
  roleName: string;
  assignRolePermissionRequest: AssignRolePermissionRequest;
};
export type GetRolePermissionsAsyncApiResponse =
  /** status 200 OK */ RolePermissionViewModel[];
export type GetRolePermissionsAsyncApiArg = {
  roleName: string;
};
export type RemoveRolePermissionAsyncApiResponse = unknown;
export type RemoveRolePermissionAsyncApiArg = {
  roleName: string;
  id: string;
};
export type CreateModuleAsyncApiResponse = /** status 201 Created */ string;
export type CreateModuleAsyncApiArg = {
  createModuleRequest: CreateModuleRequest;
};
export type GetAllModulesAsyncApiResponse =
  /** status 200 OK */ ModuleViewModel[];
export type GetAllModulesAsyncApiArg = void;
export type DeleteModuleAsyncApiResponse = unknown;
export type DeleteModuleAsyncApiArg = {
  id: string;
};
export type GetRolePermissionsByRoleNameAsyncApiResponse =
  /** status 200 OK */ RolePermissionsGroupedViewModel;
export type GetRolePermissionsByRoleNameAsyncApiArg = {
  roleName: string;
};
export type BulkUpdateRolePermissionsAsyncApiResponse = unknown;
export type BulkUpdateRolePermissionsAsyncApiArg = {
  roleName: string;
  body: RolePermissionDto[];
};
export type RemoveRoleFromUserAsyncApiResponse = unknown;
export type RemoveRoleFromUserAsyncApiArg = {
  userId: string;
  roleName: string;
};
export type AssignRoleToUserAsyncApiResponse = unknown;
export type AssignRoleToUserAsyncApiArg = {
  userId: string;
  roleName: string;
};
export type GetRoleUsersAsyncApiResponse =
  /** status 200 OK */ BackofficeUserViewModel[];
export type GetRoleUsersAsyncApiArg = {
  roleName: string;
};
export type DeleteRoleAsyncApiResponse = unknown;
export type DeleteRoleAsyncApiArg = {
  roleId: string;
};
export type CreateRoleAsyncApiResponse = unknown;
export type CreateRoleAsyncApiArg = {
  createRoleRequest: CreateRoleRequest;
};
export type GetAllPermissionRolesAsyncApiResponse =
  /** status 200 OK */ PermissionRoleViewModel[];
export type GetAllPermissionRolesAsyncApiArg = void;
export type GetUserContractsByTypeAsyncApiResponse =
  /** status 200 OK */ UserContractViewModelPaginationResponseRead;
export type GetUserContractsByTypeAsyncApiArg = {
  type: UserContractType;
  onlyActive: boolean;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type CreateUserContractAsyncApiResponse = /** status 200 OK */ string;
export type CreateUserContractAsyncApiArg = {
  createUserContractRequest: CreateUserContractRequest;
};
export type GetUserContractApprovalStatusAsyncApiResponse =
  /** status 200 OK */ UserContractApprovalStatusDto;
export type GetUserContractApprovalStatusAsyncApiArg = {
  type: UserContractType;
};
export type ApproveUserContractAsyncApiResponse =
  /** status 200 OK */ UserContractApprovalResult;
export type ApproveUserContractAsyncApiArg = {
  contractId: string;
};
export type UpdateUserStatusAsyncApiResponse = unknown;
export type UpdateUserStatusAsyncApiArg = {
  userId: string;
  updateUserStatusRequest: UpdateUserStatusRequest;
};
export type UpdateUserAsyncApiResponse = unknown;
export type UpdateUserAsyncApiArg = {
  userId: string;
  updateUserRequest: UpdateUserRequest;
};
export type DeleteUserAsyncApiResponse = unknown;
export type DeleteUserAsyncApiArg = {
  userId: string;
};
export type SetUserPasswordAsyncApiResponse = unknown;
export type SetUserPasswordAsyncApiArg = {
  userId: string;
  setUserPasswordRequest: SetUserPasswordRequest;
};
export type GetAllUsersAsyncApiResponse =
  /** status 200 OK */ BackofficeUserViewModelPaginationResponseRead;
export type GetAllUsersAsyncApiArg = {
  roleName?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type CreateSystemUserAsyncApiResponse =
  /** status 201 Created */ CreateSystemUserResponse;
export type CreateSystemUserAsyncApiArg = {
  createSystemUserRequest: CreateSystemUserRequest;
};
export type AuditLogViewModel = {
  id?: string;
  action?: string | null;
  targetId?: string | null;
  performedBy?: string | null;
  performedByName?: string | null;
  performedByEmail?: string | null;
  isSuccess?: boolean;
  errorDetails?: string | null;
  performedAt?: string;
};
export type AuditLogPagedResult = {
  items?: AuditLogViewModel[] | null;
  page?: number;
  pageSize?: number;
  totalCount?: number;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type RefreshTokenCommandResponse = {
  accessToken?: string | null;
  refreshToken?: string | null;
};
export type RefreshTokenRequest = {
  refreshToken?: string | null;
};
export type CurrentUserDto = {
  userId?: string | null;
  username?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roles?: string[] | null;
  isContractApproved?: boolean;
  contractApprovedAt?: string | null;
};
export type LoginResponse = {
  accessToken?: string | null;
  refreshToken?: string | null;
  tokenType?: string | null;
  expiresIn?: number;
};
export type LoginRequest = {
  username?: string | null;
  password?: string | null;
};
export type ChangePasswordRequest = {
  currentPassword?: string | null;
  newPassword?: string | null;
};
export type RuntimePermissionGrantDto = {
  moduleName?: string | null;
  subModuleName?: string | null;
  scopeName?: string | null;
};
export type RuntimeRolePermissionsDto = {
  roleName?: string | null;
  permissions?: RuntimePermissionGrantDto[] | null;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type ScopeViewModel = {
  id?: string;
  name?: string | null;
};
export type SubModuleViewModel = {
  id?: string;
  name?: string | null;
  scopes?: ScopeViewModel[] | null;
};
export type ModuleViewModel = {
  id?: string;
  name?: string | null;
  subModules?: SubModuleViewModel[] | null;
};
export type CreateSubModuleRequest = {
  name?: string | null;
};
export type SubModuleViewModel1 = {
  id?: string;
  name?: string | null;
  moduleId?: string;
};
export type CreateScopeRequest = {
  name?: string | null;
};
export type ScopeViewModel1 = {
  id?: string;
  name?: string | null;
};
export type AssignRolePermissionRequest = {
  moduleId?: string;
  subModuleId?: string | null;
  scopeId?: string | null;
};
export type RolePermissionViewModel = {
  id?: string;
  roleName?: string | null;
  moduleId?: string | null;
  subModuleId?: string | null;
  scopeId?: string | null;
};
export type CreateModuleRequest = {
  name?: string | null;
};
export type ScopeItemViewModel = {
  scopeId?: string;
  scopeName?: string | null;
};
export type SubModuleWithScopesViewModel = {
  subModuleId?: string;
  subModuleName?: string | null;
  scopes?: ScopeItemViewModel[] | null;
};
export type ModuleWithSubModulesViewModel = {
  moduleId?: string;
  moduleName?: string | null;
  subModules?: SubModuleWithScopesViewModel[] | null;
};
export type RolePermissionsGroupedViewModel = {
  roleName?: string | null;
  modules?: ModuleWithSubModulesViewModel[] | null;
};
export type RolePermissionDto = {
  moduleId?: string | null;
  subModuleId?: string | null;
  scopeId?: string | null;
};
export type BackofficeUserViewModel = {
  id?: string | null;
  username?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  enabled?: boolean;
  emailVerified?: boolean;
  createdAt?: string;
  roles?: string[] | null;
};
export type CreateRoleRequest = {
  name?: string | null;
  description?: string | null;
};
export type PermissionRoleViewModel = {
  id?: string;
  name?: string | null;
};
export type UserContractType =
  | 'termsOfUse'
  | 'privacyPolicy'
  | 'kvkk'
  | 'confidentialityAgreement';
export type UserContractViewModel = {
  id?: string;
  type?: UserContractType;
  title?: string | null;
  content?: string | null;
  version?: string | null;
  isActive?: boolean;
  createdAt?: string;
};
export type UserContractViewModelPaginationResponse = {
  items?: UserContractViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type UserContractViewModelPaginationResponseRead = {
  items?: UserContractViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type CreateUserContractRequest = {
  type?: UserContractType;
  title?: string | null;
  content?: string | null;
  version?: string | null;
};
export type UserContractApprovalStatusDto = {
  contractId?: string;
  type?: UserContractType;
  userId?: string | null;
  isApproved?: boolean;
  approvedAt?: string | null;
};
export type UserContractApprovalResult = {
  approvalId?: string;
  contractId?: string;
  userId?: string | null;
  approvedAt?: string;
};
export type UpdateUserStatusRequest = {
  enabled?: boolean;
};
export type UpdateUserRequest = {
  email?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roles?: string[] | null;
};
export type SetUserPasswordRequest = {
  newPassword?: string | null;
};
export type BackofficeUserViewModelPaginationResponse = {
  items?: BackofficeUserViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type BackofficeUserViewModelPaginationResponseRead = {
  items?: BackofficeUserViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type CreateSystemUserResponse = {
  userId?: string | null;
};
export type CreateSystemUserRequest = {
  email?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roles?: string[] | null;
  password?: string | null;
};
export const {
  useGetAuditLogsAsyncQuery,
  useRefreshAsyncMutation,
  useGetCurrentUserAsyncQuery,
  useLoginAsyncMutation,
  useChangePasswordAsyncMutation,
  useGetRuntimeRolePermissionsAsyncQuery,
  useSeedModulesAsyncMutation,
  useGetModulesWithSubModulesAsyncQuery,
  useCreateSubModuleAsyncMutation,
  useGetSubModulesAsyncQuery,
  useDeleteSubModuleAsyncMutation,
  useCreateScopeAsyncMutation,
  useGetAllScopesAsyncQuery,
  useAssignRolePermissionAsyncMutation,
  useGetRolePermissionsAsyncQuery,
  useRemoveRolePermissionAsyncMutation,
  useCreateModuleAsyncMutation,
  useGetAllModulesAsyncQuery,
  useDeleteModuleAsyncMutation,
  useGetRolePermissionsByRoleNameAsyncQuery,
  useBulkUpdateRolePermissionsAsyncMutation,
  useRemoveRoleFromUserAsyncMutation,
  useAssignRoleToUserAsyncMutation,
  useGetRoleUsersAsyncQuery,
  useDeleteRoleAsyncMutation,
  useCreateRoleAsyncMutation,
  useGetAllPermissionRolesAsyncQuery,
  useGetUserContractsByTypeAsyncQuery,
  useCreateUserContractAsyncMutation,
  useGetUserContractApprovalStatusAsyncQuery,
  useApproveUserContractAsyncMutation,
  useUpdateUserStatusAsyncMutation,
  useUpdateUserAsyncMutation,
  useDeleteUserAsyncMutation,
  useSetUserPasswordAsyncMutation,
  useGetAllUsersAsyncQuery,
  useCreateSystemUserAsyncMutation,
} = injectedRtkApi;
